export default {
  notify: {
    requiredField: 'Поле обов\'язкове'
  },
  btn: {
    sign: 'Увійти',
    detail: 'Детально',
    save: 'Зберегти',
    add: 'Додати',
    open: 'Відкрити',
    delete: 'Видалити',
    cancel: 'Відхилити',
    setCourse: 'Призначити курс',
    close: 'Закрити',
    readKey: 'Зчитати ключ',
    signDocument: 'Підписати'
  },
  lang: {
    ukInstrumental: 'українською',
    enInstrumental: 'англійською',
    ruInstrumental: 'російською',
    uk: 'Українська',
    en: 'Англійська',
    ru: 'Російська'
  }
}
